<template>
  <BaseModal
    name="addNoteModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('addNoteModal')"
      ></button>

      <div>
        <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
          {{ dataLang["vehicle_modal_notes_title"] }}
        </div>

        <div class="tw-mb-[15px]" ref="vehicle_notes__note">
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="vehicle_notes__note"
            @input="updateValue"
            :value="dataForEmit.vehicle_notes__note"
            maxLength="65"
          >
          </BaseInputNew>
          <div class="tw-text-forText tw-text-[12px] tw-mt-[5px]">
            {{ dataLang["vehicle_modal_notes_warning"] }}
          </div>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('addNoteModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["vehile_modal_btn_reset"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            {{ dataLang["vehile_modal_btn_save"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import EventBus from "@/event-bus.js";
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      submitting: false,
      dataForEmit: {
        vehicle_notes__note: null,
      },
    };
  },
  methods: {
    beforeClose(event) {
      this.dataForEmit.vehicle_notes__note = null;
      Object.keys(this.dataForEmit).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.remove("input-error");
        }
      });
    },
    updateValue(data) {
      this.dataForEmit.vehicle_notes__note = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    sendData() {
      this.submitting = true;
      ObjectService.createNote(this.optionalParams.id, this.dataForEmit)
        .then((data) => {
          this.$toast.success("Запись добавлена");
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
          this.$modal.hide("addNoteModal");
          this.dataForEmit.vehicle_notes__note = null;
        })
        .catch((err) => {
          Object.keys(err.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(err.response.data.message, { duration: 5000 });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  mounted() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
